import HttpService from "../Services/HttpService";
import CubeHelp from "../Models/CubeHelp";
import UpdateCubeHelpRequest from "../Requests/Cubes/UpdateCubeHelpRequest";
import {DifficultyType} from "../Models/Cube";

class CubeHelpRepository
{
  public async getByCubeId(cubeId: string, difficulty: DifficultyType): Promise<CubeHelp>
  {
    const url = `/CubeHelp/${cubeId}/${difficulty}`;
    return await HttpService.get<CubeHelp>(url);
  }

  public async update(cubeHelp: CubeHelp): Promise<CubeHelp>
  {
    const url = '/CubeHelp';
    const request: UpdateCubeHelpRequest = {
      cubeId: cubeHelp.cube.id,
      difficulty: cubeHelp.difficulty,
      rules: cubeHelp.rules,
      additionalInfo: cubeHelp.additionalInfo,
      resetInfo: cubeHelp.resetInfo,
      simplifyInfo: cubeHelp.simplifyInfo
    }
    return await HttpService.put<CubeHelp>(url, request);
  }
}

export const cubeHelpRepository = new CubeHelpRepository();